import React from 'react';
import moment from 'moment';

/**
 * Wizard-style save bar used under every request-section editor.
 * Only renders when there are unsaved changes (editing=true) or a save is in flight.
 * When idle it is completely hidden so the page stays clean.
 */
const SaveBar = ({ editing, saving, onSave, onCancel, updatedAt }) => {
	if (!editing && !saving) return null;

	return (
		<div className="pr-save-bar">
			{updatedAt && (
				<span className="pr-save-bar-meta">
					Last updated {moment(updatedAt).fromNow()}
				</span>
			)}
			<div className="pr-save-bar-actions">
				<button
					type="button"
					className="pr-btn-cancel"
					onClick={onCancel}
					disabled={saving}
				>
					Cancel
				</button>
				<button
					type="button"
					className="pr-btn-save"
					onClick={onSave}
					disabled={saving}
				>
					{saving ? 'Saving…' : 'Save changes'}
				</button>
			</div>
		</div>
	);
};

export default SaveBar;
